import React, { createContext, useCallback, useContext, useState } from 'react';

interface FlashMessageContextType {
  message: string | null;
  type: 'success' | 'danger' | 'info' | null;
  index: number;
  setFlashMessage: (
    msg: string | null,
    type?: 'success' | 'danger' | 'info'
  ) => void;
}

const FlashMessageContext = createContext<FlashMessageContextType>({
  message: null,
  type: null,
  index: 0,
  setFlashMessage: () => {},
});

export const FlashMessageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [message, setMessageState] = useState<string | null>(null);
  const [type, setType] = useState<'success' | 'danger' | 'info' | null>(null);
  const [index, setIndex] = useState<number>(0);

  const setFlashMessage = useCallback(
    (
      msg: string | null,
      messageType: 'success' | 'danger' | 'info' = 'info'
    ) => {
      setMessageState(msg);
      setType(msg ? messageType : null);
      setIndex((prev) => prev + 1);
    },
    []
  );

  return (
    <FlashMessageContext.Provider
      value={{ message, type, index, setFlashMessage }}
    >
      {children}
    </FlashMessageContext.Provider>
  );
};

export const useFlashMessage = () => useContext(FlashMessageContext);
